module.exports = __webpack_public_path__ + "img/no_registers.720d89a1.png";